type NavElementProps = {
  title: string;
  index: number;
  active: boolean;
  handleActiveTab: (index: number) => void;
};

export const NavElement = ({ title, index, active, handleActiveTab }: NavElementProps) => {
  return (
    <button
      onClick={() => handleActiveTab(index)}
      className={`rounded-lg focus:outline-hidden ${active ? "bg-brand700 text-white" : "bg-transparent text-gray-700"} px-3 py-2 text-sm font-medium`}
    >
      {title}
    </button>
  );
};
